import moment from 'moment-timezone';
import jstz from 'jstz';
import _ from 'lodash';
import zipcode_to_timezone from 'zipcode-to-timezone';

const { BROWSER } = process.env;

const formatDate = (dateTimeValue, format = 'h:mm A') => {
  if (BROWSER) {
    const browserTimezone = jstz.determine();
    const date = moment(new Date(dateTimeValue));
    return date.tz(browserTimezone.name()).format(format);
  } else {
    return '';
  }
};

const formatDateWithAffiliateZipcode = (dateTimeValue, format = 'h:mm A') => (affiliateZipcode) => {
  // if client-side, ignore affiliateZipcode; Uncomment the following section if want to display local time on the client-side
  // if (BROWSER) {                          
  //   return formatDate(dateTimeValue, format);
  // }

  const timezone = zipcode_to_timezone.lookup(affiliateZipcode);
  const date = moment(new Date(dateTimeValue));
  return date.tz(timezone).format(format);
};


const formatShortDate = (dateTimeValue, format = 'MMMM Do Y, h:mm a') => {
  let shortDateFormat = format;
  if ((new Date().getFullYear() === (new Date(dateTimeValue)).getFullYear())) {
    shortDateFormat = format.replace(/\s*Y+/g, '');
  }
  return formatDate(dateTimeValue, shortDateFormat);
};

const formatWsiDate = (wsiDateString) => {
  const dateParts = wsiDateString.split(":");
  const year = "20" + dateParts[0];
  const month = dateParts[1] - 1;
  const day = dateParts[2];
  const hours = dateParts[3];
  const mins = dateParts[4];
  const secs = dateParts[5];
  const date = new Date(Date.UTC(year, month, day, hours, mins, secs));

  return (date.toISOString());
};

const SECS_IN_HOUR = 60 * 60;
const SECS_IN_DAY = SECS_IN_HOUR * 24;
const SECS_IN_MONTH = SECS_IN_DAY * 30;
const SECS_IN_YEAR = SECS_IN_DAY * 365;

const elapsedTimeFrom = (dateToCompare, date = new Date(), displayToSecond = false, displayDetailWhenMoreThanADay = false) => {
  const elapsedTimeInSecs = Math.max(Math.floor((date - dateToCompare) / 1000), 0);
  const elapsedTime = {
    y: {
      value: Math.floor(elapsedTimeInSecs / SECS_IN_YEAR),
      text: 'year',
      displayMore: displayDetailWhenMoreThanADay
    },
    M: {
      value: Math.floor((elapsedTimeInSecs % SECS_IN_YEAR) / SECS_IN_MONTH),
      text: 'month',
      displayMore: displayDetailWhenMoreThanADay
    },
    d: {
      value: Math.floor((elapsedTimeInSecs % SECS_IN_MONTH) / SECS_IN_DAY),
      text: 'day',
      displayMore: displayDetailWhenMoreThanADay
    },
    h: {
      value: Math.floor((elapsedTimeInSecs % SECS_IN_DAY) / SECS_IN_HOUR),
      text: 'hr'
    },
    m: {
      value: Math.floor((elapsedTimeInSecs % SECS_IN_HOUR) / 60),
      text: 'min'
    },
    s: {
      value: displayToSecond ? Math.floor(elapsedTimeInSecs % 60) : 0,
      text: 'sec'
    }
  };

  let dateString = '';

  Object.keys(elapsedTime).some(key => {
    const {
      value,
      text,
      displayMore = true
    } = elapsedTime[key];
    if (value) {
      dateString += `${value} ${text}${value > 1 ? 's' : ''} `;
      return !displayMore;
    }
    return false;
  });

  return dateString.trim();
};

const getYearsSince = (since = 1900) => {
  if (isNaN(since)) {
    return [];
  }
  const currentYear = new Date().getFullYear();
  return _.range(currentYear, since - 1, -1);
};

const convertHoursToSeconds = (hours) => {
  return Math.max(hours, 0) * 3600 * 1000;
};

const getDateTimeInSeconds = () => {
  return (new Date()).getTime();
};

const getDateTimeFromJSONDate = (jsonDate) => {
  const {
    years,
    months,
    date,
    hours,
    minutes,
    seconds
  } = moment.parseZone(jsonDate).toObject();
  return new Date(Date.UTC(years, months, date, hours, minutes, seconds));
};

const getMonthNames = () => ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export {
  formatDate,
  formatDateWithAffiliateZipcode,
  formatShortDate,
  formatWsiDate,
  elapsedTimeFrom,
  convertHoursToSeconds,
  getDateTimeInSeconds,
  getYearsSince,
  getDateTimeFromJSONDate,
  getMonthNames
};



// WEBPACK FOOTER //
// ./app/utils/DateUtils.js